

















































































































































































































import { computed, defineComponent, PropType, ref, Ref, nextTick, h } from '@vue/composition-api';
import {
  BulkUploadFormData,
  UploadLocationsItem,
  CurrentLocationStatus,
  LocationTypeListInterface,
  LocationTypeValue,
} from '../types';
import { genDefaultLocationItem, MAX_COUNT, REDEX_PASTE_SEPARATE_SYMBOL } from '../const';
import { differenceBy } from 'lodash-es';
import { Message } from 'byted-vui';
import TtamLocationBulkUploadFile from './upload-file.vue';
import { i18n } from '@tt4b/ttam-i18n';
import { TranslateResult } from 'vue-i18n';
const name = 'ttam-location-bulk-upload';
export default defineComponent({
  name,
  components: {
    TtamLocationBulkUploadFile,
  },
  props: {
    invalidLocationList: {
      type: Array as PropType<UploadLocationsItem[]>,
      default: () => [],
    },
    notSupportedLocationList: {
      type: Array as PropType<UploadLocationsItem[]>,
      default: () => [],
    },
    notMatchedLocationList: {
      type: Array as PropType<UploadLocationsItem[]>,
      default: () => [],
    },
    countryListMap: {
      type: Object as PropType<{
        string: {
          label: TranslateResult;
          value: string;
        }[];
      }>,
      default: () => ({}),
    },
    locationTypeList: {
      type: Array as PropType<LocationTypeListInterface[]>,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    uploadFileSupportConfig: {
      type: Object as PropType<{
        locationType: LocationTypeValue[];
      }>,
      default: () => ({ locationType: [] }),
    },
    maxNumber: {
      type: Number,
      default: MAX_COUNT,
    },
    checkInputContent: {
      type: Function as PropType<(param: any) => Promise<{ refresh: boolean }>>,
      default: () => () => {
        refresh: false;
      },
    },
  },
  setup(props, { emit }) {
    const { checkInputContent } = props;
    const isDialogVisible = ref(false);
    const isUploadLoading = ref(false);
    const isNeedRefresh = ref(false);
    const refreshMessageNode = ref(null);
    const isAddLoading = ref(false);
    const bulkUploadFormData: Ref<BulkUploadFormData> = ref({
      locationType: LocationTypeValue.ZIP_CODE,
      country: '',
      locations: [genDefaultLocationItem()],
    });

    const defaultLocationType = computed(() => props.locationTypeList[0]?.value);
    const currentCountryList = computed(() => props.countryListMap[bulkUploadFormData.value.locationType] || []);
    const defaultCountry = computed(() => currentCountryList.value[0]?.value);

    const isSupportUploadFile = computed(() => {
      const supportLocationType = props.uploadFileSupportConfig?.locationType ?? [];
      const { locationType } = bulkUploadFormData.value;
      return supportLocationType.includes(locationType);
    });

    const showZipCodeBetaTips = computed(() => bulkUploadFormData.value.locationType === LocationTypeValue.ZIP_CODE);
    const invalidLocationCount = computed(() => props.invalidLocationList.length);
    const notSupportedLocationCount = computed(() => props.notSupportedLocationList.length);
    const notMatchedLocationCount = computed(() => props.notMatchedLocationList.length);
    const isErrorTipVisble = computed(() =>
      Boolean(invalidLocationCount.value || notSupportedLocationCount.value || notMatchedLocationCount.value),
    );
    const currentLocationsListLength = computed(() => bulkUploadFormData.value.locations?.length);

    const hasCheckingItem = computed(() => bulkUploadFormData.value.locations.some(item => item.readonly));

    const isAddBtnDisabled = computed(() => {
      const { locations } = bulkUploadFormData.value;
      const hasUnChecked = Boolean(locations.filter(item => (!item.checked && item.value) || item.readonly).length);
      if (locations.length === 1) {
        return !(locations[0].checked && locations[0].value && locations[0].status === CurrentLocationStatus.VAILD);
      }
      return props.maxNumber === 0 || isErrorTipVisble.value || hasUnChecked;
    });
    const uploadTips = computed(() => {
      if (bulkUploadFormData.value.locationType === LocationTypeValue.CITY) {
        return i18n.t('adgroup_location_btn_bulk_upload_city');
      }
      return i18n.t('adgroup_location_btn_upload_file');
    });

    const openBulkUploadDialog = () => {
      if (props.maxNumber <= 0) {
        Message.warning(`${i18n.t('adgroup_location_tip_select_number_limit', { num: props.maxNumber })}`);
        return;
      }
      bulkUploadFormData.value.locationType = defaultLocationType.value;
      bulkUploadFormData.value.country = defaultCountry.value;
      isDialogVisible.value = true;
    };
    const onDialogClose = () => {
      isDialogVisible.value = false;
    };

    const addOneInputBox = () => {
      const totalNumber = bulkUploadFormData.value.locations.length;
      const lastItem = bulkUploadFormData.value.locations[totalNumber - 1];
      if (lastItem?.value || totalNumber === 0) {
        if (currentLocationsListLength.value >= props.maxNumber) {
          Message.warning(`${i18n.t('adgroup_location_tip_select_number_limit', { num: props.maxNumber })}`);
          return;
        }
        bulkUploadFormData.value.locations.push(genDefaultLocationItem());
      }
    };

    const resetBulkUploadFormData = (type: 'locationType' | 'country' | 'locations' | 'all') => {
      if (type === 'locationType' || type === 'all') {
        bulkUploadFormData.value.locationType = defaultLocationType.value;
      }

      if (type === 'country' || type === 'all') {
        bulkUploadFormData.value.country = defaultCountry.value;
      }

      bulkUploadFormData.value.locations = [genDefaultLocationItem('reset')];
      isUploadLoading.value = false;
      isNeedRefresh.value = false;
      isAddLoading.value = false;
      refreshMessageNode.value?.close();
      refreshMessageNode.value = null;
      emit('reset-error-list', { isAll: true });
    };

    const handleRefresh = async () => {
      const { locations } = bulkUploadFormData.value;
      const keywords = locations?.map(item => item.value);

      if (keywords[locations.length - 1] === '') {
        keywords.pop();
      }
      const { refresh } = await checkInputContent({
        keywords,
        ...bulkUploadFormData.value,
      });
      return { refresh };
    };

    const setIsNeedRefresh = (refresh, focus = false) => {
      // 单个校验场景，有一个接口调用失败，则refresh按钮一直存在
      if (!refresh && isNeedRefresh.value && !focus) {
        return;
      }
      if (refresh && h && !refreshMessageNode.value) {
        refreshMessageNode.value = Message({
          type: 'error',
          duration: 0,
          customClass: `${name}__refreshMessage`,
          message: h('p', null, [
            h('span', null, '接口超时'),
            h('span', {
              on: {
                click: async () => {
                  setIsNeedRefresh(false, true);
                  const { refresh: _refresh } = await handleRefresh();
                  setIsNeedRefresh(_refresh);
                },
              },
              style: {
                color: '#3451F7',
                cursor: 'pointer',
              },
              domProps: {
                innerText: 'Refresh',
              },
            }),
          ]),
        });
      }

      if (!refresh) {
        refreshMessageNode.value?.close();
        refreshMessageNode.value = null;
      }
      isNeedRefresh.value = refresh;
    };

    const handleInputComplete = (item: UploadLocationsItem) => {
      const isCopyAndPaste = item.value.search(REDEX_PASTE_SEPARATE_SYMBOL) > -1;
      if (isCopyAndPaste) {
        const { locations = [], locationType, country } = bulkUploadFormData.value;

        // 这里需要避免有空字符串的情况,如：new york;;new york;
        const locationKeywords = item.value
          ?.split(REDEX_PASTE_SEPARATE_SYMBOL)
          .slice(0, props.maxNumber)
          .filter(keywords => Boolean(keywords))
          .map(keywords => keywords.trim());

        const preLocationsLength = locations?.length || 0;
        locationKeywords.forEach(locationValue => {
          const lastLocation = locations[currentLocationsListLength.value - 1];
          lastLocation.value = locationValue;
          addOneInputBox();
        });
        const newLocationsLength = bulkUploadFormData.value.locations?.length;
        // 只需要重新处理新粘贴复制的locations
        const locationsNeedCheck = locations?.slice(preLocationsLength - 1, newLocationsLength - 1);
        checkInputContent({
          keywords: locationKeywords,
          locations: locationsNeedCheck,
          locationType,
          country,
        }).then(({ refresh }) => {
          setIsNeedRefresh(refresh);
        });
      } else {
        addOneInputBox();
        const { locationType, country } = bulkUploadFormData.value;
        const locations = [item];
        const keywords = locations.map(location => location.value);
        checkInputContent({
          keywords,
          locations,
          locationType,
          country,
        }).then(({ refresh }) => {
          setIsNeedRefresh(refresh);
        });
      }
    };

    const handleInputBlur = item => {
      if (!item.readonly && !item.isMatchPanelVisible) {
        handleInputComplete(item);
      }
    };

    const handleInputEnter = (item, index) => {
      handleInputComplete(item);
      const { locations } = bulkUploadFormData.value;
      if (index === locations.length - 1) {
        let blurDom = document.querySelector(`#${locations[index]?.domId}`) as HTMLElement;
        blurDom?.blur();
      }
      nextTick(() => {
        if (index !== locations.length - 1) {
          const focusItem = locations[index + 1];
          let focusDom = document.querySelector(`#${focusItem?.domId}`) as HTMLElement;
          focusDom?.focus();
        }
      });
    };

    const onChangeLocationType = () => {
      resetBulkUploadFormData('country');
    };

    const onChangeCountry = () => {
      resetBulkUploadFormData('locations');
    };

    // 点击input由 clearable 属性生成的清空按钮时触发
    const handleDeleteOneLocation = location => {
      if (currentLocationsListLength.value === 1) {
        resetBulkUploadFormData('locations');
        return;
      }
      const { locations } = bulkUploadFormData.value;
      const index = locations.findIndex(item => item.inputId === location.inputId);
      if (index > -1) {
        locations.splice(index, 1);
        emit('reset-error-list', { status: location.status, id: location.inputId });
      }
    };

    // 移除所有invalid或not supported的location
    const removeAllInvalidAndNotSupportedLocation = () => {
      const removeList = [...props.invalidLocationList, ...props.notSupportedLocationList];
      bulkUploadFormData.value.locations = differenceBy(
        bulkUploadFormData.value.locations,
        removeList,
        item => item.inputId,
      );
      addOneInputBox();
      emit('reset-error-list', { status: CurrentLocationStatus.INVAILD });
      emit('reset-error-list', { status: CurrentLocationStatus.NOT_SUPPORTED });
    };

    // 点击not match edit按钮
    const handleMatchedLocationEdit = () => {
      const location = props.notMatchedLocationList[0];
      let locationDom = document.querySelector(`#${location?.domId}`) as HTMLElement;
      locationDom?.scrollIntoView({ block: 'center', inline: 'nearest' });
      location.isMatchPanelVisible = true;
    };
    /**
     * 从匹配的下拉列表中选择一个location
     */
    const selectOneMatchedLocation = (location: UploadLocationsItem, matchedLocation) => {
      const { locations } = bulkUploadFormData.value;
      const index = locations.findIndex(item => item.inputId === location.inputId);
      if (index > -1) {
        location.info = matchedLocation;
        location.matchList = [];
        location.isError = false;
        location.value = matchedLocation.name;
        location.status = CurrentLocationStatus.VAILD;
        locations.splice(index, 1, location);
        location.isMatchPanelVisible = false;
        emit('reset-error-list', { id: location.inputId, status: CurrentLocationStatus.NOT_MATCH });
      }
    };

    /** 点击dialog 取消按钮 */
    const handleCancelAddLocation = () => {
      resetBulkUploadFormData('all');
      onDialogClose();
    };
    /** 点击dialog add 按钮 */
    const handleAddLocation = () => {
      isAddLoading.value = true;

      setTimeout(() => {
        const { locationType, locations, country } = bulkUploadFormData.value;
        emit('add', {
          locationType,
          country,
          locations: locations.filter(location => location.value),
        });
        resetBulkUploadFormData('all');
        onDialogClose();
      });
    };

    const handleStartUploadFile = () => {
      resetBulkUploadFormData('locations');
      isUploadLoading.value = true;
    };

    const handleAnalysisExcelComplete = async list => {
      const { locations, country } = bulkUploadFormData.value;
      const keywords = list.slice(0, props.maxNumber).map(id => {
        if (country === 'US') {
          return id.padStart(5, '0');
        } else {
          return id;
        }
      });
      keywords.forEach((item, index) => {
        const location = locations[index];
        location.value = item;
        addOneInputBox();
      });

      const { refresh } = await checkInputContent({
        keywords,
        ...bulkUploadFormData.value,
      });
      isUploadLoading.value = false;
      setIsNeedRefresh(refresh);
    };

    return {
      name,
      isUploadLoading,
      bulkUploadFormData,
      openBulkUploadDialog,
      onDialogClose,
      onChangeLocationType,
      onChangeCountry,
      isDialogVisible,
      handleInputBlur,
      handleInputEnter,
      handleDeleteOneLocation,
      invalidLocationCount,
      notSupportedLocationCount,
      notMatchedLocationCount,
      isErrorTipVisble,
      removeAllInvalidAndNotSupportedLocation,
      handleMatchedLocationEdit,
      selectOneMatchedLocation,
      handleCancelAddLocation,
      handleAddLocation,
      handleStartUploadFile,
      handleAnalysisExcelComplete,
      isAddBtnDisabled,
      currentLocationsListLength,
      hasCheckingItem,
      isSupportUploadFile,
      isAddLoading,
      handleRefresh,
      currentCountryList,
      uploadTips,
      showZipCodeBetaTips,
    };
  },
});
